import { graphql } from 'gatsby';
import RichTextBlock from '@/components/RichTextBlock/RichTextBlock';
import { ImageElement } from '@kontent-ai/gatsby-components';
import StarRating from '@/components/StarRating/StarRating';
import {
  StyledArticle,
  StyledButton,
  StyledDescription,
  StyledEyebrow,
  StyledHeadline,
  StyledIcon,
  StyledImageContainer,
  StyledContent,
} from './N5050BlockTextItem.styles';

type N5050BlockTextItemProps = {
  n5050BlockTextItemElements: Queries.N5050_BLOCK_TEXT_ITEMFragment['n5050BlockTextItemElements'];
  isCampaignForm?: boolean;
};

const N5050BlockTextItem = ({
  n5050BlockTextItemElements: elements,
  isCampaignForm = false,
}: N5050BlockTextItemProps) => {
  const { eyebrow, headline, description, cta, image, icon, star_rating } = elements;
  const eyebrowValue = eyebrow?.value;
  const headlineValue = headline.value;
  const ctaValue = cta?.value;
  const hasIcon = !!icon?.value;
  const hasStarRating = !!star_rating?.value;
  const imageValue = image?.value && {
    ...image.value,
    url: image.value.url,
    description: image.value.description ?? '',
    height: image.value.height!,
    width: image.value.width!,
  };

  return (
    <StyledArticle>
      {imageValue && (
        <StyledImageContainer>
          <ImageElement
            alt={imageValue.description}
            height={imageValue.height}
            image={{ ...imageValue, image_id: imageValue.url }}
            width={imageValue.width}
          />
        </StyledImageContainer>
      )}
      {hasIcon && <StyledIcon {...icon.value} />}
      {eyebrowValue && <StyledEyebrow>{eyebrowValue}</StyledEyebrow>}
      <StyledContent isCampaignForm={isCampaignForm} hasIcon={hasIcon}>
        <StyledHeadline>{headlineValue}</StyledHeadline>
        <StyledDescription>
          <RichTextBlock
            elements={{
              rich_text_content: description,
            }}
          />
        </StyledDescription>
      </StyledContent>
      {hasStarRating && <StarRating {...star_rating.value} />}
      {ctaValue && <StyledButton {...ctaValue} variant="tertiary" />}
    </StyledArticle>
  );
};
export default N5050BlockTextItem;

export const fragment = graphql`
  fragment N5050_BLOCK_TEXT_ITEM on kontent_item_n5050_block_text_item {
    n5050BlockTextItemElements: elements {
      icon {
        value {
          url
        }
      }
      image {
        value {
          width
          url
          type
          height
          name
          description
        }
      }
      eyebrow {
        value
      }
      headline {
        value
      }
      description {
        value
        images {
          description
          height
          url
          image_id
          width
        }
        links {
          link_id
          codename
        }
        modular_content {
          ...CODE_SNIPPET
          ...TABLE
          ...VIDEO
          ...QUOTE
        }
      }
      cta {
        value {
          ...LINK
        }
      }
      star_rating {
        value {
          ...STAR_RATING
        }
      }
    }
  }
`;
